import { useCallback, useEffect, useState } from "react";

// The effect below depends on `fetcher`'s identity, so callers MUST
// memoize the fetcher they pass in (useCallback/useMemo) — an inline
// arrow function is a new identity every render and will loop forever.
export const useCollection = (fetcher) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refetch = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setData(await fetcher());
    } catch (e) {
      setError(e.message || "Failed to load");
    } finally {
      setLoading(false);
    }
  }, [fetcher]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch };
};
